import { render, staticRenderFns } from "./PasswordRecoveryModal.vue?vue&type=template&id=21f9b808&lang=pug"
import script from "./PasswordRecoveryModal.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports